module.exports = __webpack_public_path__ + "assets/images/pages/medipremium/icon-medipremium-4.png?4be2ca49";